import ReactGA from 'react-ga';
import { registerUserAction } from '@mirinae/explorer/modules/contexts/tutorial';

// GA3 event recording - deprecated - GA3 no  longer live, need to remove or recodew all calls to Evet() throughout the codebase
export const Event = (category, action, label) => {
};
